import { useQuery } from "react-query";

import axios from "axios";
import { applyAwsSystemFilterPolicy } from "utils/filter/awsSystemFilters";

import { EntityKind } from "models/entityKind";

import { UseSavedFiltersQueryResult } from "../types";

const SAVED_FILTERS_QUERY =
  "query savedFilters($req: SavedFilterInput!) {\n  savedFilters(req: $req) {\n    id\n    name\n    projectID\n    filterJSON\n    owner\n    __typename\n  }\n}\n";

// EVA-6412 SR-003 — fixes P3. The axios POST body/URL/response handling are
// UNCHANGED from the pre-refactor `loadSavedFilters` helper (BP-003); only the
// calling mechanism becomes a declarative useQuery.
export const useSavedFiltersQuery = (
  projectId: Maybe<string>,
  entityKind: EntityKind
): UseSavedFiltersQueryResult => {
  const { data, isFetching, refetch } = useQuery(
    ["savedFilters", projectId, entityKind],
    async () => {
      const response = await axios.post(process.env.REACT_APP_SAVED_FILTER_GQL_SERVICE, {
        operationName: "savedFilters",
        variables: { req: { projectID: projectId, entityKind } },
        query: SAVED_FILTERS_QUERY
      });
      if (response.status === 200) {
        const data = response.data.data;
        // EVA-257: the AWS build opens unfiltered, so the system filters are
        // reshaped here, at the edge, rather than in each reader downstream.
        return data?.savedFilters
          ? { ...data, savedFilters: applyAwsSystemFilterPolicy(data.savedFilters) }
          : data;
      }
      return null;
    },
    {
      enabled: false,
      staleTime: 0,
      refetchOnWindowFocus: false,
      keepPreviousData: true
    }
  );

  return { data, isFetching, refetch };
};
